import React, { useState } from "react";
import EmailSendRecover from "./EmailSendRecover";
import EmailSentInfo from "./EmailSentInfo";

const ForgetPasswordOTP = () => {
    const [submitOtpFlag, setsubmitOtpFlag] = useState(false);

    const handleGenerateOtp = () => {
        setsubmitOtpFlag(true);
    };

    return (
        <>
            {submitOtpFlag === false ? <EmailSendRecover handleGenerateOtp={handleGenerateOtp} /> : ""}
            {submitOtpFlag === true ? <EmailSentInfo /> : ""}
        </>
    );
};

export default ForgetPasswordOTP;
